<ng-template #OBJ_template_ref_remove>
  <div class="modal-body text-center gray-bg">
    <p>{{"remove_dialogue"|translate}}</p>
    <button type="button" class="btn btn-primary btn-circle" (click)="remove()" title="{{'confirm'|translate}}"><i class="fa fa-check"></i></button>
    <button type="button" class="btn btn-warning btn-circle" (click)="hideModal('remove')" title="{{'abort'|translate}}"><i class="fa fa-remove"></i></button>
  </div>
</ng-template>

<!-- modal for array of objects -->
<ng-template #OBJ_template_ref_modal_object>
  <div class="modal-body text-center">
    <tig-dynamic-form [ARR_form_fields]="OBJ_field?.fields" #OBJ_modal_form></tig-dynamic-form>
    <button type="button" class="btn btn-primary btn-circle" (click)="applyObject(OBJ_modal_form.OBJ_form_group)" title="{{'confirm'|translate}}"><i class="fa fa-check"></i></button>
    <button type="button" class="btn btn-warning btn-circle" (click)="hideModal(OBJ_field.name)" title="{{'abort'|translate}}"><i class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger btn-circle tig-a-t10-r10" (click)="openModal(OBJ_template_ref_remove, 'remove', OBJ_field.name)" title="{{'remove'|translate}}"
            *ngIf="BOO_allow_delete && !BOO_new_object"><i class="fa fa-minus"></i></button>
  </div>
</ng-template>

<div class="ibox-tools">
  <button *ngIf="OBJ_field?.allow_add" class="btn btn-primary btn-circle" (click)="newObject()" title="{{'new'|translate}}">
    <i class="fa fa-plus"></i></button>
</div>

<div class="table-responsive">
  <div id="tig-object-wrapper" class="dataTables_wrapper form-inline dt-bootstrap">
    <table id="tig-dt-element-objects" datatable [dtOptions]="OBJ_dt_options" class="table table-striped table-bordered hover table-full-width"></table>
  </div>
</div>
